import { Box } from "@mui/material";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import history from "utils/history";
import viewpaths from "global/constants/ViewPathConstants";
import { backLinkSx } from "../Workspaces.styles";

/** "← Back to workspaces", shared by every workspace sub-page. */
const WorkspacesBackLink = () => (
  <Box
    component="button"
    type="button"
    onClick={() => history.push(viewpaths.workspacesViewPath)}
    sx={backLinkSx}
  >
    <ArrowBackRoundedIcon aria-hidden="true" />
    Back to workspaces
  </Box>
);

export default WorkspacesBackLink;
